import React from "react";
import AddAndUpdatePerformance from "./AddAndUpdatePerformance";

const AddPerformance = () => {
  return <AddAndUpdatePerformance />;
};

export default AddPerformance;
